<template>
	<el-dialog title="首次登录验证" :visible.sync="dialogVisible" width="550px" :before-close="handleClose" class="firstSign" :close-on-click-modal="false">
		<div class="rePasswordForm">
			<el-row class="pageInx2">
				<div class="phoneinfo" v-if="userInfo.mobile">
					<span class="phonenums">当前手机号码：</span>
					{{ userInfo.mobile | changePhone }}
				</div>
				<div class="lines"></div>
				<el-form ref="reform2" :model="reform2" :rules="rules">
					<div class="inputrow">
						<el-form-item prop="valid"><el-input v-model.trim="reform2.valid" placeholder="请输入验证码"></el-input></el-form-item>
						<div class="getVali curpointer" v-show="canClick" @click.stop="getVali">点击获取验证码</div>
						<div class="timesout" v-show="!canClick">{{ second }}秒</div>
					</div>
				</el-form>
			</el-row>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" class="btns btn-icon-flex" @click.stop="surefn">
				<!-- <img src="../../../assets/img/login/xiayibu.png" alt="" />
				确 定 -->
				<i class="iconfont iconqueding btn-icon"></i>
				<span>确 定</span>
			</el-button>
			<div class="contact-number">
				手机号码换了？ 请联系：
				<span>17308491715</span>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import loginApi from '@/api/login';

export default {
	props: {
		userInfo: {
			type: Object,
			default() {
				return {
					loginName: '',
					mobile: ''
				};
			}
		}
	},
	data() {
		var validatePass = (rule, value, callback) => {
			let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;

			if (value === '') {
				callback(new Error('请输入密码'));
			} else if (!reg.test(value)) {
				callback(new Error('密码由字母加数字组成，必须大于8位且小于20位'));
			} else {
				if (this.reform3.checkPass !== '') {
					this.$refs.reform3.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.reform3.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			dialogVisible: false,
			stopClick: false,
			reform2: {
				valid: ''
			},
			pageInx: 1,
			rules: {
				valid: [
					{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}
				]
			},
			canClick: true,
			second: 60,
			timer: null
		};
	},
	components: {},
	methods: {
		show(){
			this.dialogVisible = true
		},
		handleClose(done) {
			clearInterval(this.timer);
			this.$refs['reform2'].resetFields();
			this.$reset('reform2', ['rules']);
			this.dialogVisible = false;
		},
		surefn() {
			let that = this;
			that.$refs['reform2'].validate(valid => {
				if (valid) {
					loginApi
						.submitIdentityVerify({
							mobile: that.userInfo.mobile,
							username: that.userInfo.loginName,
							verifyCode: that.reform2.valid
						})
						.then(res => {
							if (res.returnCode != '1001') {
								that.$message.error(res.returnMsg);
								return false;
							}
							that.$emit('success');
							that.handleClose();
						});
				} else {

					return false;
				}
			});
		},
		getVali() {
			if (this.stopClick) return false;
			clearInterval(this.timer);
			this.stopClick = true;
			let that = this;
			that.second = 60;
			loginApi
				.sendVerifyCode({
					mobile: that.userInfo.mobile,
					username: that.userInfo.loginName
				})
				.then(res => {
					if (res.returnCode == '1001') {
						that.canClick = false;
						that.timer = setInterval(() => {

							if (that.second === 0) {
								that.second = 60;
								clearInterval(this.timer);
								that.canClick = true;
							} else {
								that.second--;
							}
						}, 1000);
					}
					this.stopClick = false;
				});
		}
	},
	destroyed() {
		clearInterval(this.timer);
	},
	watch: {
		dialogVisible: {
			handler: function(val, oldval) {
				if (val) {
					// this.$nextTick(() => {
					// 	this.$refs['slideVerification'].mountedFn();
					// })
				} else {
					clearInterval(this.timer);
				}
			},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	},
	filters: {
		changePhone(value) {
			var len = value.length;
			var x = value.substring(3, len - 4);
			var values = value.replace(x, '****');
			return values;
		}
	}
};
</script>

<style lang="less">
.firstSign {
	.validate {
		width: 100%;
	}

	.btns {
		width: 100%;
		background-color: #0092f1;
		height: 40px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 0px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			// align-content: space-around;
			justify-content: center;
		}
	}

	.el-dialog .el-dialog__body {
		padding: 0px 100px 0px 100px;
	}
	.pageInx2 {
		.phoneinfo {
			width: 214px;
			margin: 32px auto;

			font-family: MicrosoftYaHei;
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;

			letter-spacing: 0px;
			color: #666666;

			.phonenums {
				font-size: 16px;
				font-weight: normal;
				letter-spacing: 0px;
				color: #999999;
			}
		}

		.lines {
			height: 1px;
			background-color: #dde8f2;
			margin: 20px 0px;
		}

		.inputrow {
			display: flex;
			justify-content: space-between;

			.el-form-item {
				width: 200px;
			}

			.timesout {
				width: 140px;
				height: 40px;
				background-color: #ffcb78;
				border-radius: 3px;
				border: solid 1px #ffaf31;

				font-family: MicrosoftYaHei;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;

				letter-spacing: 1px;
				color: #ffffff;
				text-align: center;
				line-height: 40px;
			}
		}

		.getVali {
			width: 140px;
			height: 40px;
			background-color: #ffa81e;
			border-radius: 3px;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			color: #ffffff;
			float: right;
			text-align: center;
			line-height: 40px;
		}
	}

	.el-dialog .el-dialog__footer {
		padding: 42px 100px 69px 100px;
	}

	.contact-number {
		margin-top: 35px;
		font-family: MicrosoftYaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #999999;
		span {
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0px;
			color: #e92a2a;
		}
	}
}
</style>
